import React from "react";
import { RemovableLabel, type RemovableProps } from "./Removable";

const RemovableCostCenterLabel = (props: RemovableProps<server.dto.CostCenter>) => {
  return <RemovableLabel {...props}>
    <CostCenterLabel value={props.value} />
  </RemovableLabel>;
};

export const CostCenterLabel = (props: { value: server.dto.CostCenter }) => {
  return <div>
    {props.value.title}
    <div className="s1_gray">{props.value.internalId}</div>
  </div>;
}

export default RemovableCostCenterLabel;